import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/contacto.css";

const SERVICE_ID = "service_pqs8w5n";
const TEMPLATE_NEGOCIO = "template_605nyea";
const PUBLIC_KEY = "nbC6rRIayPWbLc48s";

const Contacto = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const buildTemplateParams = () => ({
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    city: formData.city,
    message: formData.message,
    time: new Date().toLocaleString(),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus({ error: true, msg: "Por favor completa todos los campos." });
      return;
    }

    setIsSending(true);

    try {
      const templateParams = buildTemplateParams();

      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_NEGOCIO,
        templateParams,
        PUBLIC_KEY
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        message: "",
      });
      setEnviado(true);
    } catch (error) {
      console.error("Error al enviar mensajes con EmailJS:", error);
      setStatus({ error: true, msg: "Error al enviar el mensaje." });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="contact-form" id="contactanos">
      <div className="contacto-form-col">
        <p className="contact-kicker">Atencion personalizada</p>
        <h2 className="contact-title">Contactanos</h2>
        <p className="contact-subtitle">Cuentanos que necesitas y te respondemos pronto.</p>

        {enviado ? (
          <div className="contacto-enviado" role="status" aria-live="polite">
            <span className="contacto-enviado-icono" aria-hidden="true">✓</span>
            <p className="contacto-enviado-titulo">¡Mensaje enviado!</p>
            <p className="contacto-enviado-texto">Nos pondremos en contacto contigo en breve.</p>
          </div>
        ) : (
          <>
            <form className="contacto-form-grid" onSubmit={handleSubmit}>
              <label className="contacto-label" htmlFor="contacto-nombre">Nombre</label>
              <input
                id="contacto-nombre"
                className="contacto-input"
                type="text"
                name="name"
                placeholder="Ej. Ana Perez"
                value={formData.name}
                onChange={handleChange}
                autoComplete="name"
                required
              />

              <label className="contacto-label" htmlFor="contacto-email">Correo electronico</label>
              <input
                id="contacto-email"
                className="contacto-input"
                type="email"
                name="email"
                placeholder="tu@correo.com"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                required
              />

              <input
                type="hidden"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />

              <input
                type="hidden"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />

              <label className="contacto-label" htmlFor="contacto-mensaje">Mensaje</label>
              <textarea
                id="contacto-mensaje"
                className="contacto-input contacto-textarea"
                name="message"
                placeholder="Describe brevemente tu solicitud"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                required
              />

              <button className="contacto-enviar" type="submit" disabled={isSending}>
                {isSending ? "Enviando..." : "Enviar mensaje"}
              </button>
            </form>

            {status && (
              <p className={`contacto-p ${status.error ? "is-error" : "is-success"}`} role="status" aria-live="polite">
                {status.msg}
              </p>
            )}
          </>
        )}
      </div>

      <aside className="contacto-info-col" aria-label="Informacion de contacto">
        <h3 className="contacto-info-title">Tambien puedes contactarnos por</h3>

        <div className="contacto-info-item">
          <p className="contacto-info-label">Telefono</p>
          <a href="tel:+52(667) 285 1980">(667) 285 1980</a>
        </div>

        <div className="contacto-info-item">
          <p className="contacto-info-label">WhatsApp</p>
          <a href="https://wa.me/526671743222" target="_blank" rel="noopener noreferrer">Enviar mensaje</a>
        </div>

        <div className="contacto-info-item">
          <p className="contacto-info-label">Correo</p>
          <a href="mailto:cleanzone.ventas1@gmail.com">cleanzone.ventas1@gmail.com</a>
        </div>

        <div className="contacto-badge">
          <p>Respuesta habitual: menos de 24 horas habiles.</p>
        </div>
      </aside>
    </section>
  );
};

export default Contacto;
